import { OrganizationCreate } from "@/features/manage-organizations";
import { NavigateOptions, createFileRoute } from "@tanstack/react-router";

function OrganizationCreatePage() {
  const { redirect } = Route.useSearch();
  return <OrganizationCreate navigatePropsOnSuccess={redirect} />;
}

type OrganizationCreateSearch = {
  redirect: NavigateOptions | undefined;
};

export const Route = createFileRoute("/_auth/organization-create")({
  component: OrganizationCreatePage,
  validateSearch: (
    search: Record<string, unknown>
  ): OrganizationCreateSearch => ({
    redirect: (search.redirect as NavigateOptions) || undefined
  })
});
